export function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[var(--canvas)]">
      <div className="text-center">
        <div className="loading-orbit mx-auto mb-4" />
        <p className="text-sm font-medium text-gray-500">読み込み中...</p>
      </div>
    </div>
  );
}

export function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div
      className={`animate-spin ${sizeClasses[size]} border-primary-500 border-t-transparent rounded-full`}
      role="status"
      aria-label="読み込み中"
    />
  );
}
